module.exports = __webpack_public_path__ + "static/img/loading.c104337.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 11